import { createRoot } from "react-dom/client";
import App from "./App";
import "./assets/css/theme.css";
import "./assets/css/global.css";

createRoot(document.getElementById("root")).render(<App />);
